import { render, staticRenderFns } from "./BookImport.vue?vue&type=template&id=6ebb48fe&"
import script from "./BookImport.vue?vue&type=script&lang=js&"
export * from "./BookImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports